export default "__VITE_ASSET__7a73a24f__"